<template>
  <div v-if="detalle.length > 0">
    <div 
        v-if="mensaje !== null"
        class="text-center alert"
        :class="exito == 1?'alert-info':'alert-danger'">{{ mensaje }}</div>

    <div class="row" v-if="exito == 1">
      <div class="col-sm-12 text-center">
        <a :href="`/app.php/bazar/impresion/${detalle[0].id_compra}`" class="btn btn-sm btn-primary" target="_blank">
          Descargar Pdf de compra
        </a>
      </div>
    </div>
    <form @submit.prevent="confirmarCompra" v-if="exito == 0">

      <table class="table table-sm">
        <tbody>
          <tr>
            <th scope="row">TOTAL</th>
            <td class="text-right">Q {{ totalFormato }}</td>
          </tr>
        </tbody>
      </table>
      <div class="form-row">
        <div class="form-group col-md-12 mb-2">
          <label for="inputComentario">Comentarios</label>
          <textarea id="inputComentario" class="form-control border border-primary rounded-0" v-model="comentario" cols="4" rows="4"></textarea>
        </div>
      </div>
      <div class="form-row form-group mb-2">
        <div class="col-sm-12">
          <label for="inputTelefono">Teléfono de contacto:</label>
          <input type="text" id="inputTelefono" class="form-control border border-primary rounded-0" v-model="telefono_contacto">
        </div>
      </div>
      <div class="form-row form-group mb-2">
        <div class="col-sm-12">
          <label for="selectDirecciones">Direcciones sugeridas:</label>
          <select id="selectDirecciones" class="custom-select border border-primary rounded-0" v-model="direccion_sugerida">
            <option value="">Seleccione una dirección</option>
            <option :value="dir" v-for="(dir, i) in cat.direcciones" :key="i">{{ dir }}</option>
            <option value="-1">Otro</option>
          </select>
        </div>
      </div>
      <div class="form-row form-group mb-2" v-if="direccion_sugerida == -1">
        <div class="col-sm-12">
          <label for="inputDireccion">Direccion de entrega:</label>
          <input type="text" id="inputDireccion" class="form-control border-primary rounded-0" v-model="direccion_entrega" placeholder="Dirección personalizada">
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-md-12 text-right">
          <button 
            type="button" 
            class="btn btn-warning mr-2 rounded-pill shadow-sm px-4" 
            @click="$emit('regresar')"
            v-if="!btnGuardar"
          ><i class="fa fa-times"></i> Cancelar</button>
          <button 
            type="submit" 
            class="btn btn-primary rounded-pill shadow-sm px-4" 
            :disabled="btnGuardar"
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
              v-if="btnGuardar"
            ></span>
            <span v-else><i class="fa fa-save"></i> Confirmar</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
  import axios from 'axios';

  export default {
    name: 'BazarConfirmar',
    props: {
      total: {
        type: Number,
        required: true
      },
      emp: {
        type: Object,
        required: true
      },
      detalle: {
        type: Array,
        required: true
      }
    },
    data:() => ({
      btnGuardar: false,
      comentario: null,
      mensaje: null,
      exito: 0,
      telefono_contacto: null,
      direccion_sugerida: null,
      direccion_entrega: null,
      cat: {
        direcciones: []
      }
    }),
    created() {
      this.getDatos()
    },
    methods: {
      confirmarCompra() {
        this.btnGuardar = true;
        this.mensaje = null;

        let header = JSON.parse(localStorage.getItem(`bazar_${this.emp.dominio}`));

        axios.defaults.headers = {
          Authorization: header.token
        }

        let datos = {
          productos: this.detalle,
          comentario: this.comentario,
          total: this.total,
          telefono_contacto: this.telefono_contacto,
          direccion_entrega: this.direccion_entrega
        }

        let totalItem = 0;
        this.detalle.forEach(e => {
          totalItem += parseInt(e.cantidad)
        });

        axios
        .post('/app.php/bazar/confirmar_compra', datos)
        .then(res => {
          this.mensaje = res.data.mensaje;
          this.exito = res.data.exito;
          if (this.exito) {
            this.$emit('actSaldo', res.data.saldo);
            this.$emit('actTotal', totalItem  );
          }
          this.btnGuardar = false;
        }).catch(e => {
          this.btnGuardar = false;
          this.mensaje = e;
        });
      },
      getDatos() {
        axios
          .get('/app.php/bazar/get_direcciones')
          .then(res => {
            this.cat.direcciones = res.data
          }).catch(e => {
            this.btnGuardar = false;
            alert('Datos '+e);
          })
      }
    },
    computed: {
      totalFormato () {
        return new Intl.NumberFormat("es-GT", {minimumFractionDigits: 2}).format(this.total)
      }
    },
    watch: {
      direccion_sugerida(direccion) {
        this.direccion_entrega = ''
        if (direccion != -1) {
          this.direccion_entrega = direccion
        }
      }
    }
  }
</script>